import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { StackedGallery, VerticalImageGallery } from '@dmm/lib-react-ui-components';
import { prepareMediaItemsForStackedGallery, populateMediaArray, prepareMediaItemsForVerticalImageGallery } from '../../utils/listingHelper';
import './styles.css';
import { BREAKPOINTS } from '../../utils/commonHelper';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import {
  getTitle,
  getLocation,
  getPrice,
  currencyFormattingOptions
} from '../../utils/listingHelper';
import { TITLE_FORMAT } from '../../constants/boatDetails/index';

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import {
  trackContactFormOpen
} from '../../store/actions/dataLayer';
import { getMessages } from '../../tppServices/translations/messages';


const ModalWrapper = ({ children }) => {
  return (
    <Modal isOpen={true} className="stacked-gallery-modal" overlayClassName="stacked-gallery-modal-overlay" ariaHideApp={false}>
      <div>{children}</div>
    </Modal>
  );
};

ModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const StackedGalleryModal = (props) => {
  const {
    listing,
    onClickShare,
    hideModal,
    breakpoint,
    customUom,
    handlePhoneCall,
    handleOpenContactForm,
    isOpening
  } = props;

  const intl = useIntl();
  const t = intl.formatMessage;
  const locale = intl.locale;
  const messages = getMessages();

  const isMobile = breakpoint === BREAKPOINTS.mobile;
  let galleryMediaItems = populateMediaArray(listing, true);
  const mediaItems = isMobile ?
    prepareMediaItemsForStackedGallery(galleryMediaItems, isMobile) :
    prepareMediaItemsForVerticalImageGallery(galleryMediaItems);
  const thumbnailList = [...mediaItems];
  const handleCloseModal = () => {
    hideModal();
  };

  const handleContact = () => {
    handleOpenContactForm();
    if (isOpening === undefined || isOpening) {
      props.trackContactFormOpen();
    }
  };

  const titleFormat = `${TITLE_FORMAT} | {length}`;
  const title = props.show && getTitle(listing, false, titleFormat, locale, customUom);
  const customOptions = currencyFormattingOptions(locale);

  const price = getPrice(listing, customOptions);
  const taxStatus = get(listing, 'legal.taxStatus', undefined);
  const taxMessage = taxStatus ? t(messages.taxStatus[taxStatus]) : '';

  useEffect(() => {
    const handleBodyOverflow = () => {
      document.body.style.overflow = props.show ? 'hidden' : 'auto';
    };
    handleBodyOverflow();

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [props.show]);

  if (!props.show) {
    return null;
  }

  return (
    <ModalWrapper>
      <>
        {isMobile &&
          <StackedGallery onClickBack={handleCloseModal} onClickShare={onClickShare}>
            {mediaItems}
          </StackedGallery>
        }
        {!isMobile &&
          <VerticalImageGallery
            title={title}
            location={getLocation(listing)}
            price={`${price} ${!/\d/.test(price) ? '' : taxMessage}`}
            phoneNumber= {listing.contact?.phone || ''}
            phoneText={t(messages.contactGroup?.phoneReveal)}
            onClickPhoneMessage={handlePhoneCall}
            contactButtonText={t(messages.contactGroup.contact)}
            onClickContact={handleContact}
            onClickClose={handleCloseModal}
            mediaItemList={mediaItems}
            thumbnailList={thumbnailList}
          >
          </VerticalImageGallery>
        }
      </>
    </ModalWrapper>
  );
};

StackedGalleryModal.propTypes = {
  listing: PropTypes.object,
  hideModal: PropTypes.func,
  show: PropTypes.bool,
  onClickShare: PropTypes.func,
  breakpoint: PropTypes.string,
  customUom: PropTypes.shape({
    name: PropTypes.string,
    abbr: PropTypes.string.isRequired,
    symbol: PropTypes.string
  }),
  intl: PropTypes.shape({
    locale: PropTypes.string
  }),
  handlePhoneCall: PropTypes.func,
  handleOpenContactForm: PropTypes.func,
  trackContactFormOpen: PropTypes.func,
  isOpening: PropTypes.bool
};

  export default connect(null, (dispatch) =>
    bindActionCreators(
      {
        trackContactFormOpen
      },
      dispatch
    )
  )(injectIntl(StackedGalleryModal));
